import { render, staticRenderFns } from "./RecordPanel.vue?vue&type=template&id=7979685d"
import script from "./RecordPanel.vue?vue&type=script&lang=js"
export * from "./RecordPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports